import * as React from 'react';

import {FeatureGatePage} from 'shells/billing/feature-gate/feature-gate-page';
import type {FeatureName} from 'shells/billing/feature-gate/features-list';

import type {LimitedType} from 'nutshell-graphql-types';

import {analyticsClient} from '../../../analytics-client';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {useGetLimitsByType} from '../use-get-limits-by-type';

type DetailTextBullet = React.ReactNode | string;

type Props = {
    header: string;
    subHeader: string;
    bullets: DetailTextBullet[];
    greyBullets?: boolean;
    feature: FeatureName;
    icon?: any;
    shouldShowButton?: boolean;
    needLicenses?: boolean;
    noClosingMessage?: boolean;
    buttonText?: string;
    href?: string;
    limitsType?: LimitedType;
};

export function FeatureGatePageWrapper(props: Props) {
    const {limitsType, ...restProps} = props;
    const {user, isLoading} = useGetSessionUser();
    const {limits} = useGetLimitsByType(limitsType, !limitsType);
    const userCanAccessBilling = Boolean(user && user.permissions.canAccessBilling);

    if (isLoading) {
        return <div className='background-white full-height full-width' />;
    }

    return (
        <FeatureGatePage
            {...restProps}
            analyticsClient={analyticsClient}
            isAdmin={userCanAccessBilling}
            upgradePlanName={
                limits && limits.upgradePlanName !== limits.currentPlanName
                    ? limits.upgradePlanName
                    : null
            }
        />
    );
}
